import { CATEGORIES } from './checkout';
import { PAYMENT_CATEGORIES, PAYOUT_CATEGORIES, REGEXES } from './global';
import { FIELDS_TYPES } from 'consts/tokenization';

export enum BeneficiaryEntityTypes {
  individual = 'individual',
  company = 'company'
}

export enum BeneficiaryPayoutMethods {
  bank = CATEGORIES.bank,
  card = CATEGORIES.card
}

export interface BeneficiaryOptionalFields {
  identification_type?: string;
  identification_value?: string;
  company_name?: string;
  first_name?: string;
  last_name?: string;
}

export const BENEFICIARY_FORM_FIELDS = {
  first_name: 'first_name',
  last_name: 'last_name',
  company_name: 'company_name',
  country: 'country',
  pomt: 'pomt',
  requiredFields: 'required_ields',
  identification_type: 'identification_type',
  identification_value: 'identification_value',
  card_expiration_month: 'card_expiration_month',
  card_expiration_year: 'card_expiration_year',
  card_expiration: 'card_expiration',
  card_number: 'card_number',
  address: 'address',
  city: 'city',
  date_of_incorporation: 'date_of_incorporation',
  country_of_incorporation: 'country_of_incorporation',
  date_of_birth: 'date_of_birth',
  nationality: 'nationality',
  gender: 'gender'
};

export const MANDATORY_BENEFICIARY_FIELDS_BY_ENTITY = {
  [BeneficiaryEntityTypes.individual]: [
    BENEFICIARY_FORM_FIELDS.first_name,
    BENEFICIARY_FORM_FIELDS.last_name
  ],
  [BeneficiaryEntityTypes.company]: [BENEFICIARY_FORM_FIELDS.company_name]
};

export const EXTENDED_BENEFICIARY_FIELDS_BY_ENTITY = {
  [BeneficiaryEntityTypes.individual]: [
    BENEFICIARY_FORM_FIELDS.identification_type,
    BENEFICIARY_FORM_FIELDS.identification_value,
    BENEFICIARY_FORM_FIELDS.first_name,
    BENEFICIARY_FORM_FIELDS.last_name,
    BENEFICIARY_FORM_FIELDS.date_of_birth,
    BENEFICIARY_FORM_FIELDS.gender,
    BENEFICIARY_FORM_FIELDS.nationality,
    BENEFICIARY_FORM_FIELDS.address,
    BENEFICIARY_FORM_FIELDS.city,
    BENEFICIARY_FORM_FIELDS.country
  ],
  [BeneficiaryEntityTypes.company]: [
    BENEFICIARY_FORM_FIELDS.identification_type,
    BENEFICIARY_FORM_FIELDS.identification_value,
    BENEFICIARY_FORM_FIELDS.company_name,
    BENEFICIARY_FORM_FIELDS.date_of_incorporation,
    BENEFICIARY_FORM_FIELDS.country_of_incorporation,
    BENEFICIARY_FORM_FIELDS.address,
    BENEFICIARY_FORM_FIELDS.city,
    BENEFICIARY_FORM_FIELDS.country
  ]
};

export const PAGE_TITLES_BY_CATEGORY = {
  [PAYOUT_CATEGORIES.card]: {
    pomtPlaceholder: 'select_card_search',
    requiredFieldsTitle: 'beneficiary_card_details',
    countryTitle: 'beneficiary_country_section_subtitle_card'
  },
  [PAYOUT_CATEGORIES.bank]: {
    pomtPlaceholder: 'select_bank_search',
    requiredFieldsTitle: 'beneficiary_bank_account_details',
    countryTitle: 'beneficiary_country_section_subtitle'
  },
  [PAYOUT_CATEGORIES.ewallet]: {
    pomtPlaceholder: 'select_wallet_search',
    requiredFieldsTitle: 'beneficiary_ewallet_account_details',
    countryTitle: 'beneficiary_country_section_subtitle'
  }
};

export const BENEFICIARY_FIELDS_DATA: Record<
  string,
  { name: string; regex: string; type?: string }
> = {
  first_name: {
    name: BENEFICIARY_FORM_FIELDS.first_name,
    regex: REGEXES.EMPTY_REGEX
  },
  last_name: {
    name: BENEFICIARY_FORM_FIELDS.last_name,
    regex: REGEXES.EMPTY_REGEX
  },
  date_of_birth: {
    name: BENEFICIARY_FORM_FIELDS.date_of_birth,
    regex: REGEXES.DATE,
    type: FIELDS_TYPES.date
  },
  gender: {
    name: BENEFICIARY_FORM_FIELDS.gender,
    regex: REGEXES.GENDER
  },
  nationality: {
    name: BENEFICIARY_FORM_FIELDS.nationality,
    regex: REGEXES.COUNTRY_CODE,
    type: FIELDS_TYPES.country
  },
  address: {
    name: BENEFICIARY_FORM_FIELDS.address,
    regex: REGEXES.EMPTY_REGEX
  },
  city: {
    name: BENEFICIARY_FORM_FIELDS.city,
    regex: REGEXES.EMPTY_REGEX
  },
  country: {
    name: BENEFICIARY_FORM_FIELDS.country,
    regex: REGEXES.COUNTRY_CODE,
    type: FIELDS_TYPES.country
  },
  identification_type: {
    name: BENEFICIARY_FORM_FIELDS.identification_type,
    regex: REGEXES.identification_type
  },
  identification_value: {
    name: BENEFICIARY_FORM_FIELDS.identification_value,
    regex: REGEXES.identification_value
  },
  company_name: {
    name: BENEFICIARY_FORM_FIELDS.company_name,
    regex: REGEXES.EMPTY_REGEX
  },
  country_of_incorporation: {
    name: BENEFICIARY_FORM_FIELDS.country_of_incorporation,
    regex: REGEXES.COUNTRY_CODE,
    type: FIELDS_TYPES.country
  },
  date_of_incorporation: {
    name: BENEFICIARY_FORM_FIELDS.date_of_incorporation,
    regex: REGEXES.DATE,
    type: FIELDS_TYPES.date
  }
};

export enum IDENTIFICATION_TYPES_OPTIONS {
  work_permit = 'work_permit',
  international_passport = 'international_passport',
  identification_id = 'identification_id',
  social_security = 'social_security',
  residence_permit = 'residence_permit',
  company_registered_number = 'company_registered_number',
  drivers_license = 'driver\'s_license'
}
